import { render, staticRenderFns } from "./LEDSetting.vue?vue&type=template&id=8c9e49f0&scoped=true&"
import script from "./LEDSetting.vue?vue&type=script&lang=js&"
export * from "./LEDSetting.vue?vue&type=script&lang=js&"
import style0 from "./LEDSetting.vue?vue&type=style&index=0&id=8c9e49f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9e49f0",
  null
  
)

export default component.exports